export const lastPrivacyPolicyDate = 1593907200;